export default "__VITE_ASSET__5fcf00dc__"